module.exports = __webpack_public_path__ + "img/goals.feba9c81.svg";